import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-start space-x-4 text-base sm:text-sm" }
const _hoisted_2 = { class: "flex-none mt-1" }
const _hoisted_3 = ["href", "alt", "title"]
const _hoisted_4 = ["src", "alt", "title"]
const _hoisted_5 = { class: "flex-grow" }
const _hoisted_6 = ["href", "alt", "title"]
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "text-xs" }


import {ShowDto} from "@/dtos";


export default /*@__PURE__*/_defineComponent({
  __name: 'ShowCardStacked',
  props: {
    show: {}
  },
  setup(__props: any) {

const props = __props

const show: ShowDto = props.show;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: `/${_unref(show).urlSlug}`,
        alt: _unref(show).title,
        title: _unref(show).title,
        class: "guide-img-container"
      }, [
        _createElementVNode("img", {
          class: "object-cover w-8 rounded-lg shadow-lg",
          src: _unref(show).logo,
          alt: `${_unref(show).title} logo`,
          title: `${_unref(show).title} logo`
        }, null, 8, _hoisted_4)
      ], 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("a", {
        href: `/${_unref(show).urlSlug}`,
        alt: _unref(show).title,
        title: _unref(show).title,
        class: "block font-medium hover:underline"
      }, [
        _createElementVNode("h3", _hoisted_7, _toDisplayString(_unref(show).title), 1)
      ], 8, _hoisted_6),
      _createElementVNode("dl", null, [
        _cache[0] || (_cache[0] = _createElementVNode("dt", { class: "sr-only" }, "Category", -1)),
        _createElementVNode("dd", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(show).category), 1)
        ])
      ])
    ])
  ]))
}
}

})